module.exports = __webpack_public_path__ + "img/info4-lens.e961f1c1.svg";